import { Contract } from 'ethers';
export const PERS_STATUS_TOKEN_ETHERS_METHOD_BUILDER = (contract, methodName) => {
    try {
        // Use unknown first, then cast to the expected type
        const method = contract[methodName];
        if (!method)
            throw new Error(`Method ${String(methodName)} not found`);
        return method;
    }
    catch (err) {
        console.error(`Error building method ${String(methodName)}`, err);
        throw err;
    }
};
export const PERS_REWARD_TOKEN_ETHERS_METHOD_BUILDER = (contract, methodName) => {
    try {
        const method = contract[methodName];
        if (!method)
            throw new Error(`Method ${String(methodName)} not found`);
        return method;
    }
    catch (err) {
        console.error(`Error building method ${String(methodName)}`, err);
        throw err;
    }
};
export const PERS_CREDIT_TOKEN_ETHERS_METHOD_BUILDER = (contract, methodName) => {
    try {
        const method = contract[methodName];
        if (!method)
            throw new Error(`Method ${String(methodName)} not found`);
        return method;
    }
    catch (err) {
        console.error(`Error building method ${String(methodName)}`, err);
        throw err;
    }
};
export const PERS_UNIVERSAL_PROXY_ETHERS_METHOD_BUILDER = (contract, methodName) => {
    try {
        const method = contract[methodName];
        if (!method)
            throw new Error(`Method ${String(methodName)} not found`);
        return method;
    }
    catch (err) {
        console.error(`Error building method ${String(methodName)}`, err);
        throw err;
    }
};
export const PERS_GENERIC_ETHERS_METHOD_BUILDER = (contract, methodName) => {
    try {
        const method = contract[methodName];
        if (!method)
            throw new Error(`Method ${String(methodName)} not found`);
        return method;
    }
    catch (err) {
        console.error(`Error building method ${String(methodName)}`, err);
        throw err;
    }
};
/**
 * Helper function to create an Ethers contract instance with proper typing
 */
export const createPERSEthersContract = (address, abi, signerOrProvider) => {
    return new Contract(address, abi, signerOrProvider);
};
/**
 * Helper function to validate that a contract supports a specific method
 */
export const validateContractMethod = (contract, methodName) => {
    try {
        return typeof contract[methodName] === 'function';
    }
    catch {
        return false;
    }
};
/**
 * Alternative approach: Return the raw Ethers BaseContractMethod
 * This preserves the Ethers typing while still providing method access
 */
export const PERS_ETHERS_METHOD_BUILDER = (contract, methodName) => {
    try {
        const method = contract[methodName];
        if (!method)
            throw new Error(`Method ${methodName} not found`);
        return method;
    }
    catch (err) {
        console.error(`Error building method ${methodName}`, err);
        throw err;
    }
};
